module.exports = __webpack_public_path__ + "img/h4-2.7f674fbd.png";